import createStateReducer from "../../helpers/createStateReducer";
import states from "../../states/personalInformationModal";
import deltas from "../../actions/deltas";

const {SET_PERSONAL_INFORMATION_MODAL_STATE} = deltas.actionTypes;

export default createStateReducer(states, states.CLOSED, SET_PERSONAL_INFORMATION_MODAL_STATE);
